<template lang="pug">
    .searchbox-container
        v-autocomplete#v-searchbox-input(
            ref="autocomplete" 
            append-icon="search" 
            hide-no-data 
            :loading="loading" 
            cache-items 
            return-object 
            v-model="selectedItem"
            item-text="text" 
            :items="options" 
            :search-input.sync="input"
            background-color="white" 
            light box label="(F2) Buscar" 
            @keyup="searchHandler($event)" 
            @input="selectHandler()"
            @blur="$emit('blur')"
        )
</template>

<script>
export default {
    name: 'search-box',
    props: {
        model:{
            type: Object,
            default: null
        },
        service: {
            default: () => null
        },
        value: {
            default: null
        },
        displayAttributes: {
            type: Array,
            default: () => []
        }
    },
    data: function(){
        return {
            input: '',
            options: [],
            selectedItem: {},
            loading: false
        }
    },
    computed: {},
    methods: {
        searchHandler: async function(e){
            //Exclude keys
            if([38,40].includes(e.keyCode)) return
            if(this.input && this.input.length >= 3){
                if(this.service){
                    this.loading = this.colors.complement
                    this.options = await this.getByService(this.input)
                    this.options = this.options.map(option => {
                        option.text = this.displayAttributes.reduce((total, attr) => {
                            return total += ('"' + option[attr] + '" - ')
                        }, '')
                        option.text = option.text.slice(0, -3)
                        return option
                    })
                    this.loading = false
                }
            }
        },
        selectHandler: function(){
            this.$emit('input', this.selectedItem)
            this.resetSearchbox()
        },
        getByService: async function(input){
            let result = await this.service.getLike(input)
            return result
        },
        getByModel: function(){},
        resetSearchbox: function(){
            this.selectedItem = {},
            this.input = ''
            this.options = []
            this.blurInput()
        },
        blurInput: function(){
            this.$nextTick(()=>{
                this.$refs.autocomplete.blur()
            })
        },

    },
    watch: {
    },
    components: {},
    mixins: [],
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    // created: function(){...},
    // beforeMount: function(){...},
    // mounted: function(){...},
    // beforeUpdate: function(){...},
    // updated: function(){...},
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss" scoped>
    .searchbox-container{
        min-width: 100px;
        width: 100%;
        overflow: hidden;
        border-bottom-right-radius: 15px;        
        border-bottom-left-radius: 15px;        
    }

    @media screen and (min-width: 960px){
        .searchbox-container{
            padding-top:7px;
        }
    }
</style>


